import http from '../../../../api/http';
import type { Usuario, Rol, CreateUsuarioRequest } from '../types/usuario.types';

export const usuarioService = {
  async getAll(): Promise<Usuario[]> {
    const response = await http.get('/usuario');
    return response.data;
  },

  async getById(id: number): Promise<Usuario> {
    const response = await http.get(`/usuario/${id}`);
    return response.data;
  },

  async getByUserName(userName: string): Promise<Usuario> {
    const response = await http.get(`/usuario/username/${userName}`);
    return response.data;
  },

  async save(usuario: Usuario): Promise<Usuario> {
    if (usuario.id === 0) {
      const response = await http.post('/usuario', usuario);
      return response.data;
    } else {
      const response = await http.put(`/usuario/${usuario.id}`, usuario);
      return response.data;
    }
  },

  async createConPersona(request: CreateUsuarioRequest): Promise<Usuario> {
    const response = await http.post('/usuario/con-persona', request);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/usuario/${id}`);
  },

  async asignarRoles(idUsuario: number, idsRoles: number[]): Promise<void> {
    await http.post(`/usuario/${idUsuario}/roles`, idsRoles);
  },

  async getRoles(idUsuario: number): Promise<Rol[]> {
    const response = await http.get(`/usuario/${idUsuario}/roles`);
    return response.data;
  },

  async cambiarPassword(idUsuario: number, nuevaPassword: string): Promise<void> {
    await http.put(`/usuario/${idUsuario}/password`, { nuevaPassword });
  },

  async bloquear(idUsuario: number, bloquear: boolean): Promise<void> {
    await http.put(`/usuario/${idUsuario}/bloquear`, { bloquear });
  }
};
